import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import CoreComponent from './Core';
import $ from 'jquery';
import Modal from 'react-bootstrap/Modal'

class Base extends CoreComponent {
    constructor(props,config) {
      if (config !== undefined && config !== null)
      {
          config.filterParams.push({value:1,name:"pgn",type:"number",default:1});
          config.filterParams.push({value:20,name:"cnt",type:"number",default:20});
      }
      //config
      //filterParams => array of filter objects {value,name,type,default}
      super(props);
      this.state = {
        //اسامی فایل گزارش ها
        reports: {
          list: ''
        },
        on_add:null,
        on_edit:null,
        data: null,
        subModuleName:config.subModuleName,
        list_url: '/api/organ/' + config.subModuleName + '/',
        get_url: '/api/organ/' + config.subModuleName + '/',
        extra_fields:null,
        setting_data: null,
        confirmation: false,
        id_to_remove: null,
        id_to_edit: null,
        //{fieldName,value}
        last_keypress: $.now(),
        element_id: this.uuidv4(),

        //همه فیلترهای صفحه از این طریق مدیریت خواهد شد
        filter:'',
        //start table
        search_term: '',
        sort: '',
        sort_type: '',
        selected_values: [],
        search_inputs: [],
        //endtable
        filterParams:config.filterParams,
        action:'list'
      };
      this.state.filter = (props.filter !== undefined ? props.filter : "");
      this.setFilterParams();
    }
    //لینک افزودن رکورد جدید
    getAddNewLink(){
      return (<Link className="btn btn-success" to={"/" + this.state.subModuleName + "/new/"}>
                <i className="fa fa-plus"></i>
                <span>جدید</span>
              </Link>
      );
    }
    //لینک نمایش فرم ویرایش رکورد انتخابی
    getEditLink(id,caption){
      if (this.state.data.currentStaff.forms_mode === 1)
        return (
                <a onClick={e => this.state.on_edit(id)} className="text-light-blue hand mr-l-5">
                  <b>{caption}</b>
                </a>
        );
      else
        return (
            <Link to={"/" + this.state.subModuleName + "/edit/" + id} className="text-light-blue hand mr-l-5">
              <b>{caption}</b>
            </Link>
        );
    }
    componentWillReceiveProps(props){
      //this.setFilterParamsValue("pgn",1);
      //this.setFilterParamsValue("cnt",20);

      this.state.filter = (props.filter !== undefined ? props.filter : "");
      this.setFilterParams();
      this.refresh();
    }
    setFilterParams(){
      let filters = this.state.filter.split("-");
      for(var i = 0 ; i < filters.length ; i++ )
      {
        for(var j=0;j<this.state.filterParams.length;j++)
        {
          if (this.state.filterParams[j].name === filters[i].toLowerCase().trim())
          {
            if (this.state.filterParams[j].type === "number")
              if (!isNaN(filters[i+1])) this.state.filterParams[j].value = parseInt(filters[i+1]); 
            if (this.state.filterParams[j].type === "string")
              this.state.filterParams[j].value = filters[i+1]; 
          }     
        }         
      }
    }
    setFilterParamsValue(name,value){
      //اگر حالت مالتی سلکت سلکت باکس باشد به صورت آبجکتی از مقدار و لیبل ارسال میشود
      if (!this.isNull(value)) {
        if (typeof value === "object" && value._isAMomentObject != true)
        {
          if (value === null)
            value = ""
          else{
            let _v = '';
            value.map(v=>{
              if(_v !== '') _v += ",";
              _v += v.value; 
            });
            value = _v;
          }
        }
      }

      for(var j=0;j<this.state.filterParams.length;j++)
        if (this.state.filterParams[j].name === name)
        {
          if (this.state.filterParams[j].type === "number")
            if (!isNaN(value) && value !== '') 
              this.state.filterParams[j].value = parseInt(value);
            else
              this.state.filterParams[j].value = "";
          if (this.state.filterParams[j].type === "string")
            this.state.filterParams[j].value = value; 
        }
    }
    getFilterParamsValue(name){
      let r = null
      for(var j=0;j<this.state.filterParams.length;j++)
        if (this.state.filterParams[j].name === name)
          r = this.state.filterParams[j].value;
      return r;
    }
    getToolBar(params,callbackObject=null) {
      return null;
      return (
          [
            <a className="btn btn-app bg-blue">
              <i className="fa fa-print"></i>
              <span>چاپ</span>
            </a>
            ,
            <a className="btn btn-app bg-blue">
              <i className="fa fa-file-pdf-o"></i>
              <span>PDF</span>
            </a>
            ,
            <a className="btn btn-app bg-blue" onClick={e => this.excel(e)}>
              <i className="fa fa-file-excel-o"></i>
              <span>اکسل</span>
            </a>
            ,
            <a className="btn btn-app bg-blue" onClick={e => this.FeildSettings(e)}>
              <i className="fa fa-cog"></i>
              <span>تنظیمات</span>
            </a>
            ,
            <a className="btn btn-app bg-blue" onClick={e => this.ReportDesign(e)}>
              <i className="fa fa-pencil"></i>
              <span>گزارش ساز</span>
            </a>
          ]
      )
    }
    FeildSettings(t) {
      this.lockScreen();
      fetch(this.state.get_url, {
        method: 'POST',
        body: JSON.stringify({
          "action": "setting_list"
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(setting_data => {
        this.setState({ setting_data });
        this.unLockScreen();
      })
      .catch(err=>{
        this.unLockScreen();
        this.showToast("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.","danger");
      });
    }
    renderSettingForm() {
      if (this.state.setting_data != null) {
        return (
          <Modal show={true} onHide={(e) => { this.closeSettingForm(); }} dialogClassName="modal-90w" centered={true}>
            <Modal.Header closeButton>
              <Modal.Title>تنظیمات جدول</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className="row">
                  {
                    this.state.setting_data.status == 2 ? this.renderNoAccess() :
                      <div className="col-md-12">
                        <div className="box box-info">
                          <div className="form-horizontal">
                            <div className="box-body">
                              <div className="form-group">
                                <div className="col-sm-2">فیلد</div>
                                <div className="col-sm-7">عنوان فیلد</div>
                                <div className="col-sm-1">عرض ستون</div>
                                <div className="col-sm-1">اولویت</div>
                                <div className="col-sm-1">جدول</div>
                              </div>
                              {this.state.setting_data.records.map((hit, index) =>
                                <div className="form-group">
                                  <label className="col-sm-2 control-label">{hit.name}</label>
                                  <div className="col-sm-7">
                                    <input type="text" className="form-control" placeholder="عنوان فیلد" onChange={(e) => { this.setSettingFormValue(e, "caption", index) }} defaultValue={hit.caption} />
                                  </div>
                                  <div className="col-sm-1">
                                    <select className="form-control" onChange={(e) => { this.setSettingFormValue(e, "col", index) }} defaultValue={hit.col}>
                                      <option value="1">1</option>
                                      <option value="2">2</option>
                                      <option value="3">3</option>
                                      <option value="4">4</option>
                                      <option value="5">5</option>
                                      <option value="6">6</option>
                                      <option value="7">7</option>
                                      <option value="8">8</option>
                                      <option value="9">9</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                    </select>
                                  </div>
                                  <div className="col-sm-1">
                                    <input type="text" className="form-control" placeholder="اولویت" onChange={(e) => { this.setSettingFormValue(e, "order", index) }} defaultValue={hit.order} />
                                  </div>
                                  <div className="col-sm-1">
                                    <label className="switch">
                                      <input type="checkbox" onChange={(e) => { this.setSettingFormValue(e, "inOutput", index) }} defaultChecked={hit.inOutput} />
                                      <span className="slider round"></span>
                                    </label>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                  }
                </div>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" className="btn btn-default pull-left" onClick={(e) => { this.closeSettingForm(); }}>انصراف</button>
                {
                  this.state.setting_data.status == 2 ? null :
                    <button type="button" className="btn btn-primary" onClick={(e) => { this.saveSettingForm(); }}>ذخیره</button>
                }
            </Modal.Footer>
          </Modal>
        )
      }
    }
    setSettingFormValue(t, c, n) {
      if (c == 'inOutput')
        this.state.setting_data.records[n][c] = t.target.checked;
      else
        this.state.setting_data.records[n][c] = t.target.value;
    }
    closeSettingForm() {
      this.setState({
        setting_data: null,
      });
    }
    saveSettingForm() {
      this.lockScreen();
      fetch(this.state.get_url, {
        method: 'POST',
        body: JSON.stringify({
          "action": "setting_edit",
          "form": this.state.setting_data.records
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then((resualt) => {
        if (resualt.status == 1) {
          this.unLockScreen();
          this.refresh();
          this.closeSettingForm();
        }
      })
      .catch(err=>{
        this.unLockScreen();
        this.showToast("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.","danger");
      });
    }
    ReportDesign(t) {
    }
    cancelRemoveAll() {
      this.setState({ confirmationAll: false });
    }
    doRemoveAll() {
      var selectedItems = "";
      for (var i = 0; i < this.state.selected_values.length; i++) {
        if (this.state.selected_values[i] != '') {
          if (selectedItems != "")
            selectedItems += ",";
          selectedItems += this.state.selected_values[i];
        }
      }
      this.setState({ confirmationAll: false });
      this.lockScreen();
      fetch(this.state.remove_all_url, {
        method: 'POST',
        body: JSON.stringify({
          "selectedItems": selectedItems
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then((resualt) => {
        this.unLockScreen();
        if (resualt.status == 1) {
          this.refresh();
        }
        else {
          this.showToast(resualt.message, "warning");
        }
      })
      .catch(err=>this.showToast("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.","danger") );
    }
    getBaseFilter(fromPaging=false){
      let filter = '';
      for(var j=0;j<this.state.filterParams.length;j++)
      {
        //تو حالت صفحه بندی چون صفحه شماره یک به مشکل میخوره برای همین تو آدرس اضافه میکنیم
        if (this.state.filterParams[j].default !== this.state.filterParams[j].value || (fromPaging && this.state.filterParams[j].name=="pgn"))
        {
          if (filter !=='' ) filter += '-';
          filter += this.state.filterParams[j].name + '-' + this.state.filterParams[j].value;
        }     
      } 

      return filter;
    }
    cerateRequest() {
      var sort = null;
      if (this.state.sort != '')
        sort = [[this.state.sort,this.state.sort_type]];
      this.lockScreen();

      let url = this.state.list_url;
      let filter = this.getBaseFilter();
      if (filter !== '' && filter !== undefined && filter !== null)
        url += filter + "/";
      
       fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          "action": this.state.action,
          "search_inputs": this.state.search_inputs,
          "sort": sort,
          "extra_fields": this.state.extra_fields
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(data => {
        window.scrollTo(0,0);
        if (data.status == 4) {
          window.location.href = "/organ/login"
        }
        this.setState({ data });
        this.unLockScreen();
      })
      .catch(err=>{
        this.showToast("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.","danger");
        this.unLockScreen();
      });
    }
    componentDidMount() {
      this.cerateRequest();
    }
    excel(t) {
      this.setState({ id_to_edit: 0 });
      fetch(this.state.get_url, {
        method: 'POST',
        body: JSON.stringify({
          "action": "excel",
          "sheetName": "sheetName",
          "search_term": this.state.search_term,
          "sort": this.state.sort
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        return res.json();
      }).then(res => {
        var link = document.createElement("a");
        link.href = res.url;
        link.download = 'فهرست کاربران.xlsx';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
      })
      .catch(err=>this.showToast("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.","danger") );
    }
    refresh(e) {
      //وقتی فیلتر جستجو عوض میشه بایستی به صفحه اول برگردیم و تعداد نمایش در صفحه رو هم ریست کنیم
      if ( e!== undefined){
        e.preventDefault();
        this.setFilterParamsValue("pgn",1);
      }
      this.cerateRequest();
    }
    closeForm() {
      this.setState({
        form_data: null,
      });
    }
    render() {
      return null;
    }
    setDateRange(t) {
      var to, from;
      to = $(".range-to-example").persianDatepicker({
        altField: '.range-to-example-alt',
        format: 'YYYY-MM-DD',
        autoClose: true,
        initialValue: false,
        onSelect: function (unix) {
          to.touched = true;
          if (from && from.options && from.options.maxDate != unix) {
            var cachedValue = from.getState().selected.unixDate;
            from.options = { maxDate: unix };
            if (from.touched) {
              from.setDate(cachedValue);
            }
          }
          t.setDateRangeValues()
        }
      });
      from = $(".range-from-example").persianDatepicker({
        altField: '.range-from-example-alt',
        format: 'YYYY-MM-DD',
        autoClose: true,
        initialValue: false,
        onSelect: function (unix) {
          from.touched = true;
          if (to && to.options && to.options.minDate != unix) {
            var cachedValue = to.getState().selected.unixDate;
            to.options = { minDate: unix };
            if (to.touched) {
              to.setDate(cachedValue);
            }
          }
          t.setDateRangeValues();
        }
      });
    }
    setDateRangeValues() {
      var from = this.englishDigit(document.getElementById('fromRangeTxt').value);
      var to = this.englishDigit(document.getElementById('toRangeTxt').value);
      if (this.state.post_data != null) {
        this.state.post_data.from_date = from;
        this.state.post_data.to_date = to;
      }
      else {
        this.state.post_data = { from_date: from, to_date: to };
      }
      this.refresh();
    }
    componentDidUpdate() {
    }
    getAccessTitle(_t){
      var s = _t.CivilicaAccessType === 0 ? "دسترسی اعتباری به مقالات داخلی" : "دسترسی سالانه به مقالات داخلی";
      if (_t.isi_access_type !== '' && _t.isi_access_type !== null)
      {
        if (s !== '') s += " و ";
        s += "دسترسی اعتباری به مقالات بین اللملی";
      }
      return s;
    }
    doPrintList(isPdf = 0) {
      $('#reportViewerModal').modal('show');
      $(".modal-dialog-report-viewer").removeAttr('style');
      $(".modal-dialog-report-viewer").attr('style', 'width: 98%;height: 100%;');
      fetch(this.state.list_url, {
        method: 'POST',
        body: JSON.stringify({
          "count": -1,
          "skip": 0,
          "sort": this.getSortString(),
          "post_data": this.state.post_data,
          "search_inputs": this.state.search_inputs,
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then((data) => {
         // var options = new Stimulsoft.Viewer.StiViewerOptions();
        //  options.exports.showExportToHtml = false;
        //  options.exports.showExportToHtml5 = false;
        //  options.exports.showExportToDocument = false;
        //  options.exports.showExportToCsv = false;
       //   options.appearance.fullScreenMode = true;
        //  options.toolbar.showAboutButton = false;
       //   options.toolbar.showSendEmailButton = false;
       //   options.toolbar.viewMode = Stimulsoft.Viewer.StiWebViewMode.Continuous;
       //   options.toolbar.zoom = 100;
       //   var viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
       //   var report = new Stimulsoft.Report.StiReport();
       //   report.loadFile("/st_design/reports/" + this.state.reports.list + ".mrt?rnd=" + this.uuidv4());
       //   var dataSet = JSON.stringify(data.records);
       //   report.regData("Record", "Record", dataSet);
       //   var oo = {
       //     'Other': [{
       //       "currency": window.currencyTitle,
       //       "bussiness_name": window.bussinesName,
       //       "annual_name": window.annual_name,
       //       "logo": "/media/logo/" + window.logo
       //     }]
       //   };
       //   var dataSet2 = JSON.stringify(oo);
       //   report.regData("Other", "Other", dataSet2);
       //   viewer.report = report;
        //  if (isPdf == 1) {
       //     report.renderAsync(function () {
       //       var pdfData = report.exportDocument(Stimulsoft.Report.StiExportFormat.Pdf);
       //       var fileName = String.isNullOrEmpty(report.reportAlias) ? report.reportName : report.reportAlias;
        //      Object.saveAs(pdfData, fileName + ".pdf", "application/pdf");
        //    });
       //   }
         // viewer.renderHtml("viewerContent");
        }).catch(err=>this.showToast("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.","danger") );
    }
  }
  export default Base;